import ServiceCountersList from './ServiceCountersList';

export default ServiceCountersList;